module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard w-100 d-block",
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "pull-right mr-auto"
  }, [_c('b-nav-form', [(_vm.failedBillingList.length > 0) ? _c('ExcelExportButton', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "service-method": "getAllBilllingJobDash",
      "export-data": _vm.getExportPayload(),
      "filename": 'failed-billing-list.xlsx',
      "button-text": "Export As Excel",
      "exporting-text": "Downloading Please Wait...",
      "size": "sm",
      "variant": "warning",
      "button-class": "pull-right mb-1"
    },
    on: {
      "export-success": _vm.onExportSuccess,
      "export-error": _vm.onExportError
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Billing Series"
    },
    model: {
      value: (_vm.Filter.billingSeriesFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "billingSeriesFilter", $$v)
      },
      expression: "Filter.billingSeriesFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    staticClass: "mb-1",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Job Number"
    },
    model: {
      value: (_vm.Filter.jobNoFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobNoFilter", $$v)
      },
      expression: "Filter.jobNoFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.storeClientList,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Client Name"
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Billing Location"
    },
    model: {
      value: (_vm.Filter.billingLocationFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "billingLocationFilter", $$v)
      },
      expression: "Filter.billingLocationFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.storeBranchList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Branch"
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.storeShippingLineList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Shipping Line"
    },
    model: {
      value: (_vm.Filter.shippingLineFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingLineFilter", $$v)
      },
      expression: "Filter.shippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.jobList,
      "option-value": "jv",
      "option-text": "jt",
      "placeholder": "Job Type"
    },
    model: {
      value: (_vm.Filter.jobTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "jobTypeFilter", $$v)
      },
      expression: "Filter.jobTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.tallyStatusList,
      "option-value": "status",
      "option-text": "label",
      "placeholder": "Tally Status"
    },
    model: {
      value: (_vm.Filter.tallyStatusFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "tallyStatusFilter", $$v)
      },
      expression: "Filter.tallyStatusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "3"
    }
  }, [_c('model-list-select', {
    staticClass: "mb-1",
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Transport Type"
    },
    model: {
      value: (_vm.Filter.transportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transportTypeFilter", $$v)
      },
      expression: "Filter.transportTypeFilter"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "12",
      "center": ""
    }
  }, [_c('b-button', {
    staticClass: "mb-2",
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2 mb-2",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1), _vm._v(" "), (_vm.statusMessage) ? _c('div', {
    staticClass: "status-message mb-3",
    class: ("alert-" + _vm.statusType)
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('span', [_vm._v(_vm._s(_vm.statusMessage))]), _vm._v(" "), _c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": _vm.clearStatus
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])], 1)]) : _vm._e(), _vm._v(" "), (_vm.failedBillingList.length > 0) ? _c('div', {
    staticClass: "bulk-actions mb-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-checkbox', {
    staticClass: "mr-3",
    on: {
      "change": _vm.toggleSelectAll
    },
    model: {
      value: (_vm.selectAll),
      callback: function($$v) {
        _vm.selectAll = $$v
      },
      expression: "selectAll"
    }
  }, [_vm._v("\n                Select All\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                " + _vm._s(_vm.selectedItems.length) + " of " + _vm._s(_vm.failedBillingList.length) + " items selected\n              ")])], 1)]), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "md": "4"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.ImportSeries) + "\n          ")]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "5"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "size": "sm",
      "disabled": _vm.selectedItems.length === 0
    },
    on: {
      "click": _vm.sendSelectedToTally
    }
  }, [_c('i', {
    staticClass: "fa fa-paper-plane mr-1"
  }), _vm._v("\n              Send " + _vm._s(_vm.selectedItems.length) + " to Tally\n            ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-secondary",
      "size": "sm",
      "disabled": _vm.selectedItems.length === 0
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v("\n              Clear Selection\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "info",
      "size": "sm"
    },
    on: {
      "click": _vm.triggerExcelImport
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o mr-1"
  }), _vm._v("\n              Import Excel\n            ")])], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-3 pt-3 border-top"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', {
    staticClass: "text-muted mb-0"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v("\n                " + _vm._s(_vm.pagination.totalRows) + " Entries | Page " + _vm._s(_vm.pagination.currentPage) + " of " + _vm._s(_vm.totalPages) + "\n              ")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "6"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end"
  }, [_c('span', {
    staticClass: "text-muted mr-2"
  }, [_vm._v("Items per page:")]), _vm._v(" "), _c('model-list-select', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  })], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "excelFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".xlsx,.xls"
    },
    on: {
      "change": _vm.handleExcelFile
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.failedBillingList,
      "fields": _vm.fields,
      "per-page": _vm.pagination.perPage,
      "sort-by": _vm.pagination.sortBy,
      "sort-desc": _vm.pagination.sortDesc,
      "sort-direction": _vm.pagination.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.$set(_vm.pagination, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        _vm.$set(_vm.pagination, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "select",
      fn: function(row) {
        return [_c('b-form-checkbox', {
          attrs: {
            "value": row.item.billingId,
            "disabled": row.item.addedToTallySucessStatus == 0
          },
          model: {
            value: (_vm.selectedItems),
            callback: function($$v) {
              _vm.selectedItems = $$v
            },
            expression: "selectedItems"
          }
        })]
      }
    }, {
      key: "rowNumber",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }, {
      key: "billingInfo",
      fn: function(row1) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("Series:")]), _vm._v(" " + _vm._s(row1.item.billingSeries))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Location:")]), _vm._v(" " + _vm._s(row1.item.billingLocationName))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(row1.item.InvDate)))]), _vm._v(" "), _c('div', [_c('b-badge', {
          attrs: {
            "variant": row1.item.addedToTallySucessStatus == 1 ? 'success' : 'warning'
          }
        }, [_vm._v("\n                  " + _vm._s(row1.item.addedToTallySucessStatus == 1 ? 'Added to Tally' : 'Pending') + "\n                ")])], 1)])]
      }
    }, {
      key: "jobInfo",
      fn: function(row2) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("Job No:")]), _vm._v(" " + _vm._s(row2.item.JobNo))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm._f("moment")(row2.item.JobDate)))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Type:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(_vm._s(row2.item.jobType))])], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Transport:")]), _vm._v(" " + _vm._s(row2.item.TransportType))])])]
      }
    }, {
      key: "datesInfo",
      fn: function(row3) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("SOB:")]), _vm._v(" " + _vm._s(row3.item.SobDate || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("ETA Est:")]), _vm._v(" " + _vm._s(row3.item.EtaDestinationEstimated || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("ETA Act:")]), _vm._v(" " + _vm._s(row3.item.EtaDestinationActual || '-----------'))])])]
      }
    }, {
      key: "vesselInfo",
      fn: function(row4) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("Leg1 Vessel:")]), _vm._v(" " + _vm._s(row4.item.Leg1Vessel || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Leg1 Voyage:")]), _vm._v(" " + _vm._s(row4.item.Leg1Voyage || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("MBL No:")]), _vm._v(" " + _vm._s(row4.item.MblNo || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("MBL Date:")]), _vm._v(" " + _vm._s(row4.item.MblDate || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("HBL No:")]), _vm._v(" " + _vm._s(row4.item.HblNo || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Billing Type:")]), _vm._v(" " + _vm._s(row4.item.BillingType || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("BL Type:")]), _vm._v(" " + _vm._s(row4.item.BlType || '-----------'))])])]
      }
    }, {
      key: "freightTerms",
      fn: function(row5) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("HBL Terms:")]), _vm._v(" " + _vm._s(row5.item.FrghtTermsHbl || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("MBL Terms:")]), _vm._v(" " + _vm._s(row5.item.FrghtTermsMbl || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Liner Terms:")]), _vm._v(" " + _vm._s(row5.item.FrghtTermsLiner || '-----------'))])])]
      }
    }, {
      key: "locationInfo",
      fn: function(row6) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("Pickup:")]), _vm._v(" " + _vm._s(row6.item.Pickup || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Handover:")]), _vm._v(" " + _vm._s(row6.item.Handover || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Stuff:")]), _vm._v(" " + _vm._s(row6.item.Stuff || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("POL:")]), _vm._v(" " + _vm._s(row6.item.Pol || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("POD:")]), _vm._v(" " + _vm._s(row6.item.Pod || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("FPOD:")]), _vm._v(" " + _vm._s(row6.item.Fpod || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("POR:")]), _vm._v(" " + _vm._s(row6.item.Por || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Branch:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "secondary"
          }
        }, [_vm._v(_vm._s(row6.item.Branch || '-----------'))])], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Shipping Line:")]), _vm._v(" " + _vm._s(row6.item.Sline || '-----------'))])])]
      }
    }, {
      key: "clientInfo",
      fn: function(row7) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("Client:")]), _vm._v(" " + _vm._s(row7.item.Client))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Importer:")]), _vm._v(" " + _vm._s(row7.item.ImporterClient || '-----------'))]), _vm._v(" "), _c('div', [_c('b', [_vm._v("Exporter:")]), _vm._v(" " + _vm._s(row7.item.ExporterClient || '-----------'))])])]
      }
    }, {
      key: "userInfo",
      fn: function(row8) {
        return [_c('div', {
          staticClass: "info-group"
        }, [_c('div', [_c('b', [_vm._v("Raised By:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v(_vm._s(row8.item.RaisedBy || '-----------'))])], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Created By:")]), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": "success"
          }
        }, [_vm._v(_vm._s(row8.item.CreatedBy || '-----------'))])], 1)])]
      }
    }, {
      key: "actions",
      fn: function(row15) {
        return [_c('b-button', {
          attrs: {
            "variant": "primary",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.proceedBilling(row15.item.billingId, row15.item.jobType, row15.item.isMultiBilling, row15.item.billingSeries)
            }
          }
        }, [_vm._v("\n              " + _vm._s(row15.item.addedToTallySucessStatus == 0 ? "View Billing" : "Proceed To Billing") + "\n            ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.pagination.perPage,
      "total-rows": _vm.pagination.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.pagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.pagination, "currentPage", $$v)
      },
      expression: "pagination.currentPage"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5440352e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/tally/viewBillingDetails.vue
// module id = 2635
// module chunks = 0